function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import Modal from "react-bootstrap/Modal";
import "./TaskDetailWorkTimeLineModal.css";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Loader from "./../Loader/Loader";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import moment from "moment-timezone";
import classNames from "classnames";
import { HiChevronLeft, HiChevronRight, HiOutlineClock } from "react-icons/hi";
import { MdClose } from "react-icons/md";
import "./TaskDetailsModal.css";
var SCREENSHOT_LIMIT = 15;
var APP_LIMIT = 10;
export var TaskDetailWorkTimeLineModal = /*#__PURE__*/React.memo(function NewTaskModal(props) {
  var showTaskModal = props.showTaskModal,
    handleCloseTaskDetails = props.handleCloseTaskDetails,
    setTaskDetailsActiveTab = props.setTaskDetailsActiveTab,
    organisationId = props.organisationId,
    teamId = props.teamId,
    organisationSettings = props.organisationSettings,
    getAppUsageDetails = props.getAppUsageDetails,
    appSummaryData = props.appSummaryData,
    appSummaryError = props.appSummaryError,
    appSummaryLoading = props.appSummaryLoading,
    getScreenshotsDetails = props.getScreenshotsDetails,
    screenshotsData = props.screenshotsData,
    screenshotsError = props.screenshotsError,
    screenshotsLoading = props.screenshotsLoading,
    screenshotsFetchMore = props.screenshotsFetchMore,
    appSummaryFetchMore = props.appSummaryFetchMore;
  if (showTaskModal == null) {
    return null;
  }
  var taskId = showTaskModal.taskId,
    taskName = showTaskModal.taskName,
    projectName = showTaskModal.projectName,
    projectId = showTaskModal.projectId,
    taskDate = showTaskModal.taskDate,
    startTime = showTaskModal.startTime,
    endTime = showTaskModal.endTime,
    taskDescription = showTaskModal.taskDescription,
    userId = showTaskModal.userId;
  var handleTabSelect = function handleTabSelect(key) {
    setTaskDetailsActiveTab(key);
    if (key === "app-summary") {
      getAppUsageDetails({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          startTime: startTime,
          endTime: endTime,
          userId: userId,
          taskDate: taskDate,
          limit: APP_LIMIT,
          offset: 0
        },
        fetchPolicy: "network-only",
        skip: !teamId && !organisationId
      });
    } else if (key === "screenshot") {
      getScreenshotsDetails({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          startTime: startTime,
          endTime: endTime,
          userId: userId,
          taskDate: taskDate,
          limit: SCREENSHOT_LIMIT,
          offset: 0
        },
        // fetchPolicy: "cache-and-network",
        fetchPolicy: "network-only",
        skip: !teamId && !organisationId
      });
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: showTaskModal,
    onHide: handleCloseTaskDetails,
    centered: true,
    size: "lg",
    className: "task-tracker-task-detail-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "task-tracker-task-detail-modal-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "task-tracker-task-detail-modal-title-new"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-task-detail-modal-title-project-name"
  }, projectName), taskName)), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-task-detail-track-modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detail-task-detail-tab"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "app-summary",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "app-summary",
    title: "Apps/Websites Usage"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-task-detail-tab"
  }, appSummaryLoading ? /*#__PURE__*/React.createElement(Loader, null) : appSummaryError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(AppSummaryCard, {
    appSummaryData: appSummaryData,
    appSummaryLoading: appSummaryLoading,
    appSummaryFetchMore: appSummaryFetchMore,
    endTime: endTime
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "screenshot",
    title: "Screenshots"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-task-detail-tab"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-task-detail-edit-modal-body-container"
  }, screenshotsLoading ? /*#__PURE__*/React.createElement(Loader, null) : screenshotsError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(ScreenshotCard, {
    screenshotsData: screenshotsData,
    screenshotsFetchMore: screenshotsFetchMore,
    screenshotsLoading: screenshotsLoading,
    endTime: endTime
  }))))))));
});
export var AppSummaryCard = function AppSummaryCard(props) {
  var _appSummaryData$getPr, _appSummaryData$getPr2, _appSummaryData$getPr4, _appSummaryData$getPr5;
  var appSummaryData = props.appSummaryData,
    appSummaryLoading = props.appSummaryLoading,
    appSummaryFetchMore = props.appSummaryFetchMore,
    endTime = props.endTime;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isAppLoadingMore = _React$useState2[0],
    setAppIsLoadingMore = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isAppAllLoaded = _React$useState4[0],
    setAppIsAllLoaded = _React$useState4[1];
  if ((appSummaryData === null || appSummaryData === void 0 ? void 0 : (_appSummaryData$getPr = appSummaryData.getProjectAndTaskAppData) === null || _appSummaryData$getPr === void 0 ? void 0 : _appSummaryData$getPr.length) !== 0 && (appSummaryData === null || appSummaryData === void 0 ? void 0 : (_appSummaryData$getPr2 = appSummaryData.getProjectAndTaskAppData) === null || _appSummaryData$getPr2 === void 0 ? void 0 : _appSummaryData$getPr2.length) < APP_LIMIT && !isAppAllLoaded) {
    setAppIsAllLoaded(true);
  }
  function handleScroll(e) {
    var _appSummaryData$getPr3;
    if (appSummaryLoading) return;
    setAppIsLoadingMore(true);
    appSummaryFetchMore({
      variables: {
        offset: appSummaryData === null || appSummaryData === void 0 ? void 0 : (_appSummaryData$getPr3 = appSummaryData.getProjectAndTaskAppData) === null || _appSummaryData$getPr3 === void 0 ? void 0 : _appSummaryData$getPr3.length
      },
      updateQuery: function updateQuery(prev, _ref) {
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if (fetchMoreResult.getProjectAndTaskAppData.length < APP_LIMIT && !isAppAllLoaded) {
          setAppIsAllLoaded(true);
          setAppIsLoadingMore(false);
        }
        setAppIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getProjectAndTaskAppData: [].concat(_toConsumableArray(prev.getProjectAndTaskAppData), _toConsumableArray(fetchMoreResult.getProjectAndTaskAppData))
        });
      }
    });

    //setLimits(LIMIT + 20);
    // }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "project-task-time-mapping-modal-app-website-usage"
  }, (appSummaryData == undefined || (appSummaryData === null || appSummaryData === void 0 ? void 0 : (_appSummaryData$getPr4 = appSummaryData.getProjectAndTaskAppData) === null || _appSummaryData$getPr4 === void 0 ? void 0 : _appSummaryData$getPr4.length) == 0) && endTime == "Invalid date" ? /*#__PURE__*/React.createElement("div", {
    className: "app-summary-user-no-data"
  }, "Tracking details will be displayed here once the member completes their task. If you wish to access real-time tracking data, please visit the Screenshots and Apps History pages.") : appSummaryData == undefined || (appSummaryData === null || appSummaryData === void 0 ? void 0 : (_appSummaryData$getPr5 = appSummaryData.getProjectAndTaskAppData) === null || _appSummaryData$getPr5 === void 0 ? void 0 : _appSummaryData$getPr5.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "app-summary-user-no-data"
  }, "Your employees haven't clocked into the desktop application during this task. So no tracking happened for this task.") : /*#__PURE__*/React.createElement(Table, {
    borderless: true
  }, /*#__PURE__*/React.createElement("thead", {
    className: "project-task-time-mapping-modal-app-website-usage-header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Apps/Websites"), /*#__PURE__*/React.createElement("th", null, "Total Time"))), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement(React.Fragment, null, appSummaryData.getProjectAndTaskAppData.map(function (app) {
    return /*#__PURE__*/React.createElement("tr", {
      className: "project-task-time-mapping-modal-app-website-usage-table-content"
    }, /*#__PURE__*/React.createElement("td", null, " ", /*#__PURE__*/React.createElement("img", {
      className: "project-task-time-mapping-modal-app-website-usage-card-icon",
      src: app.icon
    }), " ", /*#__PURE__*/React.createElement("span", null, app.name)), /*#__PURE__*/React.createElement("td", null, app.totalTime));
  }), appSummaryData && appSummaryData.getProjectAndTaskAppData.length != 0 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: "2",
    className: "add-task-task-details-load-more-button"
  }, !isAppAllLoaded ? isAppLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "app-summary-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleScroll();
    },
    className: "app-summary-usage-load-more-button"
  }, "Load More") : !appSummaryData && appSummaryData && appSummaryData.getProjectAndTaskAppData.length ? /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button review-usage-light-color"
  }, "You have seen all the data") : null)) : null))));
};
export var ScreenshotCard = function ScreenshotCard(props) {
  var _screenshotsData$getP2, _screenshotsData$getP3, _screenshotsData$getP8, _screenshotsData$getP9;
  var screenshotsData = props.screenshotsData,
    screenshotsFetchMore = props.screenshotsFetchMore,
    screenshotsLoading = props.screenshotsLoading,
    endTime = props.endTime;
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isAllLoaded = _React$useState6[0],
    setIsAllLoaded = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isLoadingMore = _React$useState8[0],
    setIsLoadingMore = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadMoreButton = _React$useState10[0],
    setIsLoadMoreButton = _React$useState10[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    ImageViewerShow = _React$useState12[0],
    setImageViewerShow = _React$useState12[1];
  var _React$useState13 = React.useState(0),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    ImageViewerNextNavCount = _React$useState14[0],
    setImageViewerNextNavCount = _React$useState14[1];
  var _React$useState15 = React.useState(0),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    ImageViewerPrevNavCount = _React$useState16[0],
    setImageViewerPrevNavCount = _React$useState16[1];
  var handleClose = function handleClose() {
    var _screenshotsData$getP;
    setImageViewerShow(false);
    setImageViewerShow(null);
    setImageViewerNextNavCount(0);
    setImageViewerPrevNavCount((screenshotsData === null || screenshotsData === void 0 ? void 0 : (_screenshotsData$getP = screenshotsData.getProjectAndTaskScreenshots) === null || _screenshotsData$getP === void 0 ? void 0 : _screenshotsData$getP.length) - 1);
  };
  if ((screenshotsData === null || screenshotsData === void 0 ? void 0 : (_screenshotsData$getP2 = screenshotsData.getProjectAndTaskScreenshots) === null || _screenshotsData$getP2 === void 0 ? void 0 : _screenshotsData$getP2.length) !== 0 && (screenshotsData === null || screenshotsData === void 0 ? void 0 : (_screenshotsData$getP3 = screenshotsData.getProjectAndTaskScreenshots) === null || _screenshotsData$getP3 === void 0 ? void 0 : _screenshotsData$getP3.length) < SCREENSHOT_LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }

  // console.log({ screenshotsData });

  var handleShow = function handleShow(value, index) {
    var _screenshotsData$getP4;
    var temp = _objectSpread(_objectSpread({}, value), {}, {
      index: index
    });
    setImageViewerShow(temp);
    setImageViewerPrevNavCount((screenshotsData === null || screenshotsData === void 0 ? void 0 : (_screenshotsData$getP4 = screenshotsData.getProjectAndTaskScreenshots) === null || _screenshotsData$getP4 === void 0 ? void 0 : _screenshotsData$getP4.length) - 1);
  };
  var handleNext = function handleNext() {
    var _screenshotsData$getP5;
    var index = ImageViewerShow.index;
    index = Number(index) + 1;
    setImageViewerNextNavCount(index);
    var temp = _objectSpread(_objectSpread({}, screenshotsData === null || screenshotsData === void 0 ? void 0 : screenshotsData.getProjectAndTaskScreenshots[index]), {}, {
      index: index
    });
    if ((screenshotsData === null || screenshotsData === void 0 ? void 0 : (_screenshotsData$getP5 = screenshotsData.getProjectAndTaskScreenshots) === null || _screenshotsData$getP5 === void 0 ? void 0 : _screenshotsData$getP5.length) < index) {
      setImageViewerShow(null);
    }
    setImageViewerShow(temp);
  };
  var handlePrevious = function handlePrevious() {
    var _screenshotsData$getP6;
    var index = ImageViewerShow.index;
    index = Number(index) - 1;
    setImageViewerPrevNavCount(index);
    var temp = _objectSpread(_objectSpread({}, screenshotsData === null || screenshotsData === void 0 ? void 0 : screenshotsData.getProjectAndTaskScreenshots[index]), {}, {
      index: index
    });
    if ((screenshotsData === null || screenshotsData === void 0 ? void 0 : (_screenshotsData$getP6 = screenshotsData.getProjectAndTaskScreenshots) === null || _screenshotsData$getP6 === void 0 ? void 0 : _screenshotsData$getP6.length) > index) {
      setImageViewerShow(null);
    }
    setImageViewerShow(temp);
  };
  var handleLoadMore = function handleLoadMore() {
    var _screenshotsData$getP7;
    if (screenshotsLoading) return;

    // console.log("load more");
    setIsLoadingMore(true);
    screenshotsFetchMore({
      variables: {
        offset: screenshotsData === null || screenshotsData === void 0 ? void 0 : (_screenshotsData$getP7 = screenshotsData.getProjectAndTaskScreenshots) === null || _screenshotsData$getP7 === void 0 ? void 0 : _screenshotsData$getP7.length
      },
      // fetchPolicy: 'network-only',
      // notifyOnNetworkStatusChange: true,
      updateQuery: function updateQuery(prev, _ref2) {
        var _fetchMoreResult$getP, _fetchMoreResult$getP2;
        var fetchMoreResult = _ref2.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getP = fetchMoreResult.getProjectAndTaskScreenshots) === null || _fetchMoreResult$getP === void 0 ? void 0 : _fetchMoreResult$getP.length) === 0 && ((_fetchMoreResult$getP2 = fetchMoreResult.getProjectAndTaskScreenshots) === null || _fetchMoreResult$getP2 === void 0 ? void 0 : _fetchMoreResult$getP2.length) < SCREENSHOT_LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getProjectAndTaskScreenshots: [].concat(_toConsumableArray(prev.getProjectAndTaskScreenshots), _toConsumableArray(fetchMoreResult.getProjectAndTaskScreenshots))
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, (screenshotsData == undefined || (screenshotsData === null || screenshotsData === void 0 ? void 0 : (_screenshotsData$getP8 = screenshotsData.getProjectAndTaskScreenshots) === null || _screenshotsData$getP8 === void 0 ? void 0 : _screenshotsData$getP8.length) == 0) && endTime == "Invalid date" ? /*#__PURE__*/React.createElement("div", {
    className: "app-summary-user-no-data"
  }, "Tracking details will be displayed here once the member completes their task. If you wish to access real-time tracking data, please visit the Screenshots and Apps History pages.") : screenshotsData == undefined || (screenshotsData === null || screenshotsData === void 0 ? void 0 : screenshotsData.getProjectAndTaskScreenshots.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "app-summary-user-no-data"
  }, "Your employees haven't clocked into the desktop application during this task. So no tracking happened for this task.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "project-task-time-mapping-modal-ScreenShots-root"
  }, screenshotsData === null || screenshotsData === void 0 ? void 0 : (_screenshotsData$getP9 = screenshotsData.getProjectAndTaskScreenshots) === null || _screenshotsData$getP9 === void 0 ? void 0 : _screenshotsData$getP9.map(function (screenShotvalue, key) {
    return /*#__PURE__*/React.createElement("div", {
      //className="project-task-time-mapping-modal-screenshot-card"
      className: classNames("project-task-time-mapping-modal-screenshot-card", {
        "project-task-time-mapping-modal-screenshot-card-non-idle": Number(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.idleSeconds) > 0
      }),
      key: screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.screenshotId
      // onClick={() => handleShow(screenShotvalue, key)}
      //onClick={handleShow}
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-modal-screenshot-card-header"
    }, /*#__PURE__*/React.createElement("img", {
      className: "project-task-time-mapping-modal-screenshot-card-header-icon",
      onClick: function onClick() {
        return handleShow(screenShotvalue, key);
      },
      src: screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.appIcon
    }), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-modal-screenshot-card-header-name",
      onClick: function onClick() {
        return handleShow(screenShotvalue, key);
      }
    }, screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.appTitle)), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-modal-screenshot-card-image",
      onClick: function onClick() {
        return handleShow(screenShotvalue, key);
      }
    }, /*#__PURE__*/React.createElement("img", {
      alt: "User Screenshot",
      className: "project-task-time-mapping-modal-screenshot-card-thumbnail-image",
      src: screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.thumbnailUrl
    })), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-modal-screenshot-card-footer",
      onClick: function onClick() {
        return handleShow(screenShotvalue, key);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-modal-screenshot-card-footer-information-bar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-modal-screenshot-card-footer-information-bar-timer"
    }, /*#__PURE__*/React.createElement(HiOutlineClock, null), /*#__PURE__*/React.createElement("span", {
      className: "project-task-time-mapping-modal-screenshot-card-footer-information-bar-timer-time"
    }, moment(Number(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.addedAt)).format("hh:mm A"))))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "project-task-time-mapping-modal-screenshot-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "screenshot-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      //setIsLoadMoreButton(true);
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the screenshots")), /*#__PURE__*/React.createElement(ImageViewerModal, {
    ImageViewerShow: ImageViewerShow,
    handleClose: handleClose,
    handleNext: handleNext,
    handlePrevious: handlePrevious,
    screenshotLength: screenshotsData === null || screenshotsData === void 0 ? void 0 : screenshotsData.getProjectAndTaskScreenshots.length,
    ImageViewerNextNavCount: ImageViewerNextNavCount,
    ImageViewerPrevNavCount: ImageViewerPrevNavCount,
    from: "web"
  })));
};
var ImageViewerModal = function ImageViewerModal(props) {
  var ImageViewerShow = props.ImageViewerShow,
    handleClose = props.handleClose,
    handleNext = props.handleNext,
    handlePrevious = props.handlePrevious,
    screenshotLength = props.screenshotLength,
    ImageViewerNextNavCount = props.ImageViewerNextNavCount,
    ImageViewerPrevNavCount = props.ImageViewerPrevNavCount,
    from = props.from;
  if (ImageViewerShow == null) {
    return null;
  }
  var isWindow = typeof window !== "undefined";
  var isMobileView = window.innerWidth < 768 && from === "web";
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    className: "project-task-time-mapping-modal-screenshot",
    size: "lg",
    centered: true
  }, /*#__PURE__*/React.createElement("span", {
    className: "project-task-time-mapping-modal-screenshot-close",
    onClick: function onClick() {
      return handleClose();
    }
  }, /*#__PURE__*/React.createElement(MdClose, null)), (screenshotLength - 1 !== ImageViewerPrevNavCount || ImageViewerNextNavCount > 0 || ImageViewerShow.index != 0) && ImageViewerPrevNavCount > 0 ? /*#__PURE__*/React.createElement(HiChevronLeft, {
    className: "project-task-time-mapping-modal-screenshot-left-nav",
    onClick: function onClick() {
      return handlePrevious();
    },
    onKeyPress: function onKeyPress(event) {
      if (event.charCode === 37) {
        handlePrevious();
      }
    }
  }) : null, (screenshotLength - 1 !== ImageViewerNextNavCount || screenshotLength - 1 > ImageViewerPrevNavCount) && ImageViewerShow.index < screenshotLength - 1 ? /*#__PURE__*/React.createElement(HiChevronRight, {
    className: "project-task-time-mapping-modal-screenshot-right-nav",
    onClick: function onClick() {
      return handleNext();
    },
    onKeyPress: function onKeyPress(event) {
      if (event.keyCode === 39) {
        handleNext();
      }
    }
  }) : null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-task-time-mapping-modal-screenshot-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-task-time-mapping-modal-screenshot-personal-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-task-time-mapping-modal-screenshot-personal-header-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-task-time-mapping-modal-screenshot-site-icon-content"
  }, /*#__PURE__*/React.createElement("img", {
    src: ImageViewerShow.appIcon,
    className: "project-task-time-mapping-modal-screenshot-site-icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "project-task-time-mapping-modal-screenshot-site-icon-details"
  }, /*#__PURE__*/React.createElement("span", {
    className: "project-task-time-mapping-modal-screenshot-site-name"
  }, ImageViewerShow.appTitle), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "project-task-time-mapping-modal-screenshot-user-name"
  }, ImageViewerShow.displayName), isMobileView ? /*#__PURE__*/React.createElement("span", {
    className: "project-task-time-mapping-modal-screenshot-time"
  }, moment(Number(ImageViewerShow.addedAt)).format("hh:mm A")) : null)), isMobileView ? null : /*#__PURE__*/React.createElement("div", {
    className: "project-task-time-mapping-modal-screenshot-time-details"
  }, /*#__PURE__*/React.createElement(HiOutlineClock, {
    className: "project-task-time-mapping-modal-screenshot-time-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "project-task-time-mapping-modal-screenshot-time"
  }, moment(Number(ImageViewerShow.addedAt)).format("LLL")))), /*#__PURE__*/React.createElement("div", {
    //className="project-task-time-mapping-modal-screenshot-screenshot-image"
    className: classNames("project-task-time-mapping-modal-screenshot-screenshot-image", {
      "screenshot-card-modal-non-idle": Number(ImageViewerShow === null || ImageViewerShow === void 0 ? void 0 : ImageViewerShow.idleSeconds) > 0
    })
  }, /*#__PURE__*/React.createElement("img", {
    src: ImageViewerShow.imageUrl
  }))));
};